/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
  <ModalBaseConfirmacion>
    <section class="contenedorPrincipal">
      <section>
        <div class="contenedorLogo">
          <img class="imgLogo" src="../../assets/images/ania-logo.png" alt="Logo" />
        </div>
        <div class="separador"></div>
      </section>

      <div class="contenidoTexto">
        <h2 class="titulo">¡Recordatorio de Renovación!</h2>
        <p class="mensaje">
          Te recordamos que tu suscripción se renovará en <b>5 días</b>. 
          El cargo se aplicará automáticamente a tu tarjeta registrada.
        </p>
      </div>

      <section class="contenedorBotonesVertical">
        <button class="btnContinuar" @click="continuar">
          Continuar con la suscripción
        </button>
        
        <button class="btnCancelar" @click="solicitarCancelacion">
          Deseo cancelar
        </button>
      </section>
    </section>

    <LoadScreen v-if="showAddProducto" @cerrar="ocultarAddProd"></LoadScreen>
  </ModalBaseConfirmacion>
</template>

<script>
import ModalBaseConfirmacion from "./ModalBaseConfirmacion.vue";
import LoadScreen from "../Forms/LoadScreen.vue";

export default {
  components: {
    ModalBaseConfirmacion,
    LoadScreen,
  },
  props: {
    mostrarExito: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAddProducto: false,
    };
  },
  emits: ["continuar", "cancelar"],
  methods: {
    ocultarAddProd() {
      this.showAddProducto = false;
    },
    continuar() {
      this.$emit("continuar");
    },
    solicitarCancelacion() {
      this.$emit("cancelar");
    },
  },
};
</script>

<style scoped>
.contenedorPrincipal {
  margin: 0px 30px;
  text-align: center;
}

.contenedorLogo {
  justify-content: center;
  display: flex;
  padding: 20px 0px 10px;
}

.imgLogo {
  height: 55px;
}

.separador {
  border-top: 3px solid #2a428c;
  margin: 5px 0 25px 0;
}

.contenedorImg {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.imgE {
  height: 100px;
}

.titulo {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.mensaje {
  font-size: 17px;
  color: #666;
  line-height: 1.5;
  padding: 0 10px;
}

.contenedorBotonesVertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.btnContinuar {
  width: 100%;
  max-width: 320px;
  background-color: #29b9f6;
  color: white;
  border: none;
  padding: 14px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  transition: transform 0.2s;
}

.btnContinuar:hover {
  transform: scale(1.02);
  background-color: #7a3e1a;
}

.btnCancelar {
  background: none;
  border: none;
  color: #707070;
  text-decoration: underline;
  font-size: 15px;
  cursor: pointer;
  padding: 10px;
}

.btnCancelar:hover {
  color: #333;
}
</style>